export const menu = {
  options: ['Gami Sushi', 'White Castle', 'Gotham Steakhouse'],
  'Gami Sushi': [
    'Kappa Roll',
    'Oshinko Roll',
    'Kanpyo Roll',
    'Tamago Roll',
    'Tuna Roll',
    'Salmon Roll',
    'Negi Toro Roll',
    'Negi Hama Roll',
    'Wild Salmon Roll',
    'California Roll',
    'BC Roll',
    'Inari Roll',
    'Avocado Roll',
    'Gomae Roll',
    'Spicy Tuna Roll',
    'Spicy Salmon Roll',
    'Tuna and Avocado Roll',
    'Salmon and Avocado Roll',
    'Vegetable Roll',
    'Yam Tempura Roll',
    'Vegetable Tempura Roll',
    'Asparagus Tempura Roll',
    'Wakame Roll',
    'Dynamite Roll',
    'Smoked Yam Roll',
    'Smoked Salmon Roll',
    'Beef Teriyaki Roll',
    'Chicken Teriyaki Roll',
    'Chopped Scallop Roll',
    'Alaska Roll',
    'Unagi Roll',
    'Ebi Roll',
    'Spicy Chopped Scallop Roll',
    'Futomaki',
    'Spicy Tuna Tempura Roll',
    'Spicy Salmon Tempura Roll',
    'Deep Fried California Roll',
    'Unagi Tempura Roll',
    'Deep Fried Roll',
  ],
  'White Castle': [
    'Shrimp Nibblers',
    'The Impossible Slider with Smoked Cheddar Cheese',
    'The Original Slider',
    'Cheese Slider',
    'Bacon Cheese Slider',
    'Double Cheese Slider',
    'Crispy Chicken Breast Slider',
    'Chicken Ring Slider',
    'Bacon and Cheddar Chicken Slider',
    'Veggie Slider',
    'Panko Breaded Fish Slider',
    'Breakfast Slider',
    'Original Slider with Egg and Cheese',
    'Breakfast Toast Sandwich',
    'Belgian Waffle Slider',
    'Chicken and Waffles Slider',
    'Hash Brown Nibblers',
    'Mini Belgian Waffles',
    'One Breakfast Slider Combo',
    'Two Breakfast Slider Combo',
    'Belgian Waffle Slider Combo',
    'One Breakfast Toast Sandwich Combo',
    'Two Breakfast Toast Sandiwches Combo',
  ],
  'Gotham Steakhouse': [
    'Manhattan Clam Chowder',
    'Soup of the Day',
    'Mixed Local Organic Greens',
    'Caesar Salad',
    'Spinach Salad',
    'Beet Carpaccio',
    'Jumbo Shrimp Cocktail',
    'Crab Cake',
    'Tuna Poke',
    'Fresh Oysters',
    'Cured Salmon Two Ways',
    'Steak Tartare',
    'Cheese Toast',
    'Candied Beet Salad',
    'Citrus Salad',
    'Gotham Chopped Salad',
    'Marinated Thai Beef Salad',
    'Lobster Cobb Salad',
    'Halibut and Chips',
    'Baja Fish Tacos',
    'Prawn and Scallop Spaghettini',
    'Chicken Paillard',
    'Gotham Power Bowl',
    'Gotham Bacon Cheddar Burger',
    'New York Steak Sandwich',
    'Blackened Ahi Tuna',
    'Milk Fed Veal Chop',
    'Double Cut Lamb Chops',
    'Roasted Stuffed Half Chicken',
    'Fish Market Selection',
    'Garlic Shrimp',
    'Steak and Lobster',
  ],
};
